/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientDepartmentRequest } from './';
import {
    ClientDepartmentRequestFromJSON,
    ClientDepartmentRequestFromJSONTyped,
    ClientDepartmentRequestToJSON,
} from './';
import type { CompanyIndustryRequest } from './';
import {
    CompanyIndustryRequestFromJSON,
    CompanyIndustryRequestFromJSONTyped,
    CompanyIndustryRequestToJSON,
} from './';
import type { CompanySizeRequest } from './';
import {
    CompanySizeRequestFromJSON,
    CompanySizeRequestFromJSONTyped,
    CompanySizeRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface MissingCompanyDetailsRequest
 */
export interface MissingCompanyDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof MissingCompanyDetailsRequest
     */
    companyName?: string;
    /**
     * 
     * @type {CompanySizeRequest}
     * @memberof MissingCompanyDetailsRequest
     */
    companySize?: CompanySizeRequest;
    /**
     * 
     * @type {ClientDepartmentRequest}
     * @memberof MissingCompanyDetailsRequest
     */
    clientDepartment?: ClientDepartmentRequest;
    /**
     * 
     * @type {CompanyIndustryRequest}
     * @memberof MissingCompanyDetailsRequest
     */
    companyIndustry?: CompanyIndustryRequest;
}

/**
 * Check if a given object implements the MissingCompanyDetailsRequest interface.
 */
export function instanceOfMissingCompanyDetailsRequest(value: object): value is MissingCompanyDetailsRequest {
    return true;
}

export function MissingCompanyDetailsRequestFromJSON(json: any): MissingCompanyDetailsRequest {
    return MissingCompanyDetailsRequestFromJSONTyped(json, false);
}

export function MissingCompanyDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MissingCompanyDetailsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'companySize': json['companySize'] == null ? undefined : CompanySizeRequestFromJSON(json['companySize']),
        'clientDepartment': json['clientDepartment'] == null ? undefined : ClientDepartmentRequestFromJSON(json['clientDepartment']),
        'companyIndustry': json['companyIndustry'] == null ? undefined : CompanyIndustryRequestFromJSON(json['companyIndustry']),
    };
}

export function MissingCompanyDetailsRequestToJSON(value?: MissingCompanyDetailsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companyName': value['companyName'],
        'companySize': CompanySizeRequestToJSON(value['companySize']),
        'clientDepartment': ClientDepartmentRequestToJSON(value['clientDepartment']),
        'companyIndustry': CompanyIndustryRequestToJSON(value['companyIndustry']),
    };
}

